export default __webpack_public_path__ + "static/media/portfolio3.9538e6f7.png";